import { removeToken } from "Session";
import { User } from "contexts/types/application-context-types";

export const redirectColomboUserTo = new Map<User["userData"]["type"], string>([
  ["PARCEIRO_VENDEDOR", "/atendimentos"],
  ["COMERCIAL", "/usuarios"],
  ["PARCEIRO_MASTER", "/usuarios"],
  ["PARCEIRO_GERENTE_ESTRATEGICO", "/empresas"],
  ["PARCEIRO_GERENTE_VAREJO", "/empresas"]
]);

export const allowedUserTypesLoginColombo = Array.from(
  redirectColomboUserTo.keys()
);

export const redirectUserTo = new Map<User["userData"]["type"], string>([
  ["FINANCEIRO", "/carteira"],
  ["PARCEIRO_VENDEDOR", "/atendimentos"],
  ["PARCEIRO_OPERACIONAL", "/atendimentos"],
  ["SUPER", "/mailing"],
  ["REGIONAL", "/mailing"],
  ["COMERCIAL", "/mailing"],
  ["PARCEIRO_MASTER", "/mailing"],
  ["ASCOM", "/mailing"],
  ["PARCEIRO_GERENTE_ESTRATEGICO", "/empresas"],
  ["PARCEIRO_GERENTE_VAREJO", "/empresas"]
]);

export const userTypeRedirect = ({
  userData
}: {
  userData: User["userData"];
}) => {
  const isColomboUser = userData.customerCodigoNova?.startsWith("1309");
  const userBlocked = !!userData.accessBlocked;
  const isUserVendedor = userData.type === "PARCEIRO_VENDEDOR";
  const isUserMaster = userData.type === "PARCEIRO_MASTER";

  const licencaExpirada = !!userData.customerLicenseUserExpired;
  const quantidadeContratadaExcedida =
    !!userData.customerLicenseUserQtyExceeded;

  if (userBlocked && isUserVendedor) return "/usuario-bloqueado";
  if ((quantidadeContratadaExcedida || licencaExpirada) && isUserMaster)
    return "/confirm-licenses";

  if (
    (userData.customerLicenseUserConfigured === false || licencaExpirada) &&
    userData.type === "PARCEIRO_MASTER" &&
    !isColomboUser
  ) {
    return "/confirm-licenses";
  }

  if (isColomboUser) {
    if (redirectColomboUserTo.get(userData.type!))
      return redirectColomboUserTo.get(userData.type!)!;
    else {
      removeToken();
      return "/login";
    }
  } else {
    if (redirectUserTo.get(userData.type!)) {
      return redirectUserTo.get(userData.type!)!;
    } else {
      removeToken();
      return "/login";
    }
  }
};
